import { render } from "./LeaveReject.vue?vue&type=template&id=2143a92c"
import script from "./LeaveReject.vue?vue&type=script&lang=js"
export * from "./LeaveReject.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__